import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import {
  Box,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Grid,
  Paper,
  Alert
} from '@mui/material';
import '../css/ManageCompanies.css';
import API_BASE_URL from '../api';

const EditCompany = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [company, setCompany] = useState({ nom: '', siret: '', users: [] });
  const [allUsers, setAllUsers] = useState([]);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const token = localStorage.getItem('authToken');

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/societes/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setCompany(res.data);
      } catch {
        setError('Erreur lors de la récupération de la société');
      }
    };

    const fetchUsers = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/users`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setAllUsers(res.data);
      } catch {
        console.error('Erreur récupération utilisateurs');
      }
    };

    fetchCompany();
    fetchUsers();
  }, [id, token]);

  const handleChange = (e) => {
    setCompany(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleUserChange = (e) => {
    const { value, checked } = e.target;
    const updatedUsers = checked
      ? [...company.users, value]
      : company.users.filter((userId) => userId !== value);
    setCompany(prev => ({ ...prev, users: updatedUsers }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API_BASE_URL}/api/societes/${id}`, company, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSuccessMessage("Mise à jour réussie !");
      setError('');
      setTimeout(() => {
        setSuccessMessage('');
        navigate('/manage-companies');
      }, 3000);
    } catch {
      setError("Erreur lors de la mise à jour de la société");
    }
  };

  const handleDelete = async () => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cette entreprise ?")) {
      try {
        await axios.delete(`${API_BASE_URL}/api/societes/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setSuccessMessage("Entreprise supprimée avec succès !");
        setTimeout(() => navigate('/manage-companies'), 2000);
      } catch {
        setError("Erreur lors de la suppression");
      }
    }
  };

  return (
    <Box className="manage-companies-container">
      <Sidebar />
      <Box className="main-content">
        <Paper className="company-paper" elevation={3}>
          <Typography variant="h5" gutterBottom>Modifier la société</Typography>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {successMessage && <Alert severity="success" sx={{ mb: 2 }}>{successMessage}</Alert>}

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Nom de la société"
                  name="nom"
                  fullWidth
                  value={company.nom}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="SIRET"
                  name="siret"
                  fullWidth
                  value={company.siret}
                  onChange={handleChange}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>Associer des utilisateurs :</Typography>
                <Box className="user-checkboxes">
                  {allUsers.map((user) => (
                    <FormControlLabel
                      key={user._id}
                      control={
                        <Checkbox
                          value={user._id}
                          checked={company.users.includes(user._id)}
                          onChange={handleUserChange}
                        />
                      }
                      label={`${user.firstName} ${user.lastName} (${user.emailAddress})`}
                    />
                  ))}
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Button variant="contained" color="primary" type="submit" className="save-button">
                  Mettre à jour
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={handleDelete}
                  sx={{ ml: 2 }}
                >
                  Supprimer
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
    </Box>
  );
};

export default EditCompany;
